// extracted by mini-css-extract-plugin
export default {"cart":"cart_cart__LHih+","container":"cart_container__0qYPg","product":"cart_product__pO1zp"};